import { Component, OnInit } from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";

@Component({
  selector: 'app-vicechancellor',
  templateUrl: './vicechancellor.component.html',
  styleUrls: ['./vicechancellor.component.scss']
})
export class VicechancellorComponent implements OnInit {

  constructor( private meta: Meta,
               private titles: Title) { }

    ngOnInit(): void {
        window.scrollTo(0, 0);

        this.updateMetaTags();
    }

    updateMetaTags() {
        this.titles.setTitle('ARNI’s Vice Chancellor: Leadership for Excellence');
        this.meta.updateTag({
            name: 'description',
            content: `Discover ARNI’s Vice Chancellor, a leader fostering innovation, academic growth, and excellence. Shaping a vibrant future through visionary guidance.`
        });
    }

}
